import { AnimatePresence, motion } from "framer-motion";
import { isEmpty } from "lodash";
const ParlaySportbookInner = ({
  updatedData,
  parly,

  betSlipObject,
  handelChange,
  setSelected,
  showBetDialog,
  parlyBet,
  detail,
  setActive,
  active,
  selected,
  addToFavioute,
  favouriteList,
}) => {
  return updatedData?.map((item, index) => {
    if (item?.sportsBookSelection?.length > 0) {
      let lockOuter =
        item?.apiSiteStatus == "SUSPENDED" || item?.marketStatus != 1;
      let animate = favouriteList?.includes(item.id) ?? false;
      return (
        <div className="s-mb-3px s-rounded-5px s-bg-white dark:s-bg-black-700 s-p-3px s-pt-0 s-shadow-2sm">
          <AnimatePresence>
            <motion.div
              key={item.id}
              layout={animate} // Animate only clicked item
              initial={animate ? { opacity: 0, y: 10 } : false}
              animate={animate ? { opacity: 1, y: 0 } : {}}
              exit={{ opacity: 0 }}
              transition={{
                type: "spring",
                stiffness: 500,
                damping: 30,
                mass: 0.5,
              }}
            >
              <div
                onClick={() =>
                  setActive((prev) => {
                    if (prev.includes(index)) {
                      return prev?.filter((obj) => {
                        return obj != index;
                      });
                    } else {
                      return [...prev, index];
                    }
                  })
                }
                className="s-relative s-py-2 s-flex s-justify-start s-items-center s-rounded-t-3px s-min-h-28px"
              >
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    addToFavioute(detail?.eventId, "SportBook", item?.id);
                  }}
                  className={`${
                    animate
                      ? "s-icon-top-soild s-text-16px s-ml-4px"
                      : "s-icon-top dark:s-text-global-font-default-dark s-text-16px s-ml-4px"
                  } `}
                />
                <span className="s-text-16px s-px-7px s-flex-1 s-leading-120">
                  {item?.marketName}
                </span>
                <span
                  className={`s-transform ${
                    active.includes(index) ? "s-rotate-180" : ""
                  } s-icon-arrow-down-sencodary s-text-11px s-mt-2px s-mr-8px s-justify-self-end s-transition-transform s-origin-center s-duration-300`}
                />
              </div>
              {active.includes(index) && (
                <div className="s-grid-cols-2 s-grid s-gap-2px s-relative">
                  {item?.sportsBookSelection?.map((res, id) => {
                    if (Number(res?.odds) > 0) {
                    
                      let lock =
                        res?.isActive != 1 ||
                        item?.apiSiteStatus == "SUSPENDED" ||
                        item?.marketStatus != 1;

                      let obj =
                        parlyBet?.length > 0
                          ? parlyBet?.find((obj) => {
                              return (
                                obj?.marketName == item?.marketName &&
                                obj?.sportsBookSelectionObject?.id ==
                                  res?.id
                              );
                            })
                          : {};
                      return (
                        <div
                          onClick={(e) => {
                            if (!lock) {
                              handelChange(res?.odds, item, res, e);
                              setSelected(item?.id);
                            }
                          }}
                          style={
                            !isEmpty(obj)
                              ? {
                                  border: "1px solid #878e92",
                                  background: "rgba(0, 0, 0, .15)",
                                }
                              : {}
                          }
                          data-v-492756f4
                          className="dark:s-text-global-font-default-dark s-text-center s-flex s-flex-col s-justify-center s-items-center s-rounded-4px s-relative s-min-h-49px s-overflow-hidden s-bg-parlay-betInfo-light dark:s-bg-parlay-betInfo-dark"
                          title="back"
                        >
                          <div
                            data-v-492756f4
                            className="s-relative s-flex s-flex-col s-justify-center s-items-center s-rounded-4px s-w-full s-h-full s-text-15px"
                          >
                            <h3
                              data-v-492756f4
                              className="s-pb-1 s-px-2 s-text-11px s-font-normal s-w-full s-text-parlay-bet-text"
                            >
                              {res?.selectionName}
                            </h3>
                            <p
                              data-v-492756f4
                              className="s-text-forecast-text s-text-17px s-font-bold"
                            >
                              {res?.odds}
                            </p>
                          </div>
                        </div>
                      );
                    }
                  })}
                  {lockOuter && (
                    <div className="s-absolute s-w-full s-h-full s-bg-black-700 dark:s-bg-black-900 s-opacity-80 s-rounded-b-3px s-z-20 s-rounded-t-md">
                      <span className="s-w-full s-h-full s-flex s-justify-center s-items-center s-text-white s-text-15px">
                        Suspend
                      </span>
                    </div>
                  )}
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      );
    }
  });
};

export default ParlaySportbookInner;
